<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button
          type="primary"
          icon="ios-add"
          v-if="isHavePermission('ordersSeller:createOrUpdateOrdersSeller:0:add')"
          @click="createOrder"
      >新建承运人订单
      </Button>
      <Button
          type="primary"
          style="margin-left: 10px"
          v-if="isHavePermission('ordersSeller:batchCreateOrdersSeller:0')"
          @click="importOrder"
      >导入承运人订单
      </Button>
      <Button
          type="primary"
          style="margin-left: 10px"
          v-if="isHavePermission('ordersSeller:orderTogether')"
          @click="orderTogether"
      >撮合订单展示
      </Button>


      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px"
      >刷新
      </Button>
      <Button
          icon="md-download"
          @click="download"
          style="margin-left: 10px"
          v-if="isHavePermission('order:relationorder:download')"
      >导出
      </Button>
      <Button status="primary" v-if="isHavePermission('order:relationorder:batchDelete')" style="margin-left: 10px"
              @click="commitBatchDelete"><i class="el-icon-delete"></i>
        批量删除
      </Button>
      <Button type="primary" v-if="isHavePermission('ordersSeller:fileDelete')" style="margin-left: 10px"
              @click="commitFileDelete"><i class="el-icon-delete"></i>
        批量删除合同附件
      </Button>
      <Button type="primary" v-if="isHavePermission('ordersSeller:fileCreate')" style="margin-left: 10px"
              @click="commitFileCreate"><i class="el-icon-delete"></i>
        批量生成合同附件
      </Button>
      <Button icon="md-download"
              @click="fileDownload"
              style="margin-left: 10px"
              v-if="isHavePermission('ordersSeller:fileDownload')"
      >附件导出
      </Button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="总订单编号" field="chainNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.chainNum"
                      placeholder="输入编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item
                  title="子订单编号"
                  field="sellerOrderNum"
                  span="12"
              >
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.sellerOrderNum"
                      placeholder="输入编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单标题" field="contractTitle" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractTitle"
                      placeholder="输入订单标题"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.goodsName"
                      placeholder="输入货名"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务类别" field="contractBusType" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.contractBusType"
                      :options="contractBusTypeOption"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="附件筛查" field="hasFile" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.hasFile"
                      :options="fileOptions"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item
                  title="平台最早开票日期"
                  field="platInvoiceDate"
                  span="12"
              >
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.platInvoiceDate"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item
                  title="销项最早开票日期"
                  field="sellerInvoiceDate"
                  span="12"
              >
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.sellerInvoiceDate"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item
                  title="进项最早开票日期"
                  field="buyerInvoiceDate"
                  span="12"
              >
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.buyerInvoiceDate"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人名称" field="buyerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchBuyerName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'buyerNameOptions',
                          'ordersSeller',
                          'queryOrdersKeyword',
                          1
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'buyerNameOptions')
                    "
                      placeholder="输入托运人"
                  >
                    <Option
                        v-for="option in buyerNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人名称" field="sellerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'sellerNameOptions',
                          'ordersSeller',
                          'queryOrdersKeyword',
                          2
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'sellerNameOptions')
                    "
                      placeholder="输入承运人"
                  >
                    <Option
                        v-for="option in sellerNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesMan" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesMan"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'salesManOptions',
                          'ordersSeller',
                          'queryOrdersKeyword',
                          3
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'salesManOptions')
                    "
                      placeholder="输入业务员"
                  >
                    <Option
                        v-for="option in salesManOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="客户经理" field="salesManager" span="12">
                <template v-slot>
                  <Select
                      v-model="searchClientName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'clientNameOptions',
                          'ordersSeller',
                          'queryOrdersKeyword',
                          5
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'clientNameOptions')
                    "
                      placeholder="输入客户经理"
                  >
                    <Option
                        v-for="option in clientNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'createUserOptions',
                          'ordersSeller',
                          'queryOrdersKeyword',
                          4
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'createUserOptions')
                    "
                      placeholder="输入创建人"
                  >
                    <Option
                        v-for="option in createUserOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人类型" field="sellerUserType" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.sellerUserType"
                      :options="sellerTypeOption"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="异常校验" field="payState" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.payState"
                      :options="oldOrderErrorOption"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      type="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button
                      @click="reset"
                      style="margin-left: 10px; border-radius: 5px"
                  >重置
                  </Button
                  >
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          :loading="loading"
          :data="orderListData"
          align="center"
          :footer-method="footerMethod"
          @filter-change="filterChangeMethod"
          :filter-config="{remote: true}"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
                trigger="click"
                style="margin-left: 10px"
                transfer
                v-if="
                isHavePermission(
                  'ordersSeller:createOrUpdateOrdersSeller:0:updata'
                ) || isHavePermission('ordersSeller:removeOrdersSeller:0')
              "
            >
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                      class="button-gengduo"
                      @click="editOrder(row)"
                      v-if="isHavePermission('ordersSeller:createOrUpdateOrdersSeller:0:updata') && row.orderType !== 1">
                    编辑
                  </Button>
                  <Button
                      class="button-gengduo"
                      style="color: #ed4014"
                      @click="confirmEvent(row.id)"
                      v-if="isHavePermission('ordersSeller:removeOrdersSeller:0')"
                  >删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="chainNum" title="主订单编号" width="130">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.chainId, 0)">{{ row.chainNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="sellerOrdersNum"
            title="子订单编号"
            width="130"
        >
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.id, 2)">{{ row.sellerOrdersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractBusType" title="业务类型" width="60">
          <template slot-scope="{ row }">
            <span>{{ row.contractBusType | contractbusMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="150"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="goodsType"
            title="货物类型"
            width="120"
            align="center"
            :filters="filterGoodsType"
            :filter-multiple="false"
        >
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].goodsType
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="货名" width="105">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos[0]" class="cell-goods-name">{{
              row.goodsRtnVos[0].goodsName
            }}</span>
            <Icon
                type="ios-arrow-down"
                @click="clickEvent3($rowIndex)"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex" transfer placement="bottom">
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 1125px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      align="center"
                      :show-header="false"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="105"
                    ></vxe-table-column>
                    <!-- <vxe-table-column
                      field="rule"
                      title="规格"
                      width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="packUnit"
                      title="包装形式"
                      width="80"
                    ></vxe-table-column> -->
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="price"
                        title="单价"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="amount"
                        title="总金额"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="priceType"
                        title="计费方式"
                        width="80"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.priceType | priceTypeMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="60">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="120"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="目的地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endTime"
                        title="到达时间"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.endTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                    <!-- <vxe-table-column field="driverName" title="司机" width="100"></vxe-table-column>
                    <vxe-table-column field="driverPhone" title="手机号" width="120"></vxe-table-column> -->
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="goodsRtnVos"
          title="规格"
          width="60"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].rule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="goodsRtnVos"
          title="包装形式"
          width="80"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].packUnit
            }}</span>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="goodsRtnVos" title="单位" width="60">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].unit }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="数量" width="75">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].counts
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="单价" width="75">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].price
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="goodsRtnVos"
            title="总金额"
            width="90"
            align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].amount
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="goodsRtnVos"
            title="计费方式"
            width="80"
            align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].priceType | priceTypeMap
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="含税" width="60">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].isTax | taxMap
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="车船号" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].carShipNum
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="起运地" width="90">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].beginPlace ? row.goodsRtnVos[0].beginPlace.replace(/,/g, '') : ''
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].beginTime | timeFormatDate
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="目的地" width="90">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].endPlace ? row.goodsRtnVos[0].endPlace.replace(/,/g, '') : ''
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="到达时间" width="140">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].endTime | timeFormatDate
            }}</span>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="goodsRtnVos" title="司机" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{row.goodsRtnVos[0].driverName}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="手机号" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{row.goodsRtnVos[0].driverPhone}}</span>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="associateCounts" title="实际数量" width="150">
          <!-- <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].associateCounts }}</span>
          </template>-->
        </vxe-table-column>
        <vxe-table-column field="payAmount" title="应付金额" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.payAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.payedAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="unpayAmount" title="未付金额" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.unpayAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="invoiceAmount" title="发票总额" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.invoiceAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="platInvoiceDate"
            title="平台最早开票"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.platInvoiceDate | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="sellerInvoiceDate"
            title="销项最早开票"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.sellerInvoiceDate | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="buyerInvoiceDate"
            title="进项最早开票"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.buyerInvoiceDate | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="salesManName"
            title="业务员"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="客户经理"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="createTime"
            title="创建时间"
            width="120"
            v-if="isHavePermission('global:viewCreateTime')"
        >
          <template slot-scope="{ row }">
            <span>{{ row.updateTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="isShowAddModal"
        :title="modalTitle"
        width="1300"
        height="660"
        resize
        position="center"
    >
      <create-seller-order
          ref="createOrder"
          :isShowAddModal="isShowAddModal"
          :type="openType"
          :rowInfo="rowInfo"
          @closeModal="getCloseModalVal"
      ></create-seller-order>
    </vxe-modal>
    <vxe-modal
        v-model="templateVisible"
        title="承运人订单导入"
        width="1000"
        height="620"
        position="center"
        @close="closeTemplate"
        remember
    >
      <import
          @goImport="goImport"
          @close="closeTemplate"
          ref="modalTemplate"
      ></import>
    </vxe-modal>
    <vxe-modal
        v-model="importOrderModal"
        title="导入承运人订单"
        width="1300"
        position="center"
        height="660"
        remember
        destroy-on-close
    >
      <impot-order @createCommit="createCommit"></impot-order>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import Auth from "@/utils/auth.js";
  import Import from "@/components/common/Import"; // 导入
  import $C from "@/consts";
  import CreateSellerOrder from "@/components/order/CreateSellerOrder"; // 创建新订单
  import ImpotOrder from "@/components/order/ImpotOrder"; // 导入
  import {numberToCurrency, formatMoney} from "@/filters/type";
  import {searchTime, SEARCH_TIME} from "@/filters/time";
  import moment from "moment";

  moment.locale("zh-CN");
  import viewOrderDetail from "@/mixin/viewOrderDetail";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {
    getBlob,
    hideLoading,
    isEmpty, isNotEmpty, postBlob,
    saveBlob, showErrorData,
    showLoading,
  } from "@/utils/util";
  import {apiPost} from "@/utils/api";

  export default {
    mixins: [viewOrderDetail, getAuthOrization],
    components: {
      CreateSellerOrder,
      ImpotOrder,
      Import,
    },
    data() {
      return {
        searchLoading: false,
        searchVisible: false,
        open: false,
        contractBusTypeOption: [],
        fileOptions: $C.HAS_FILE_TYPE.options,
        timeOptions: SEARCH_TIME.options,
        searchBuyerName: [],
        searchSellerName: [],
        searchSalesMan: [],
        searchCreateUser: [],
        searchClientName: [],
        buyerNameOptions: [],
        sellerNameOptions: [],
        salesManOptions: [],
        createUserOptions: [],
        clientNameOptions: [],
        importOrderModal: false,
        templateVisible: false,
        loading: false,
        isShowAddModal: false,
        orderListData: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0,
        },
        searchFormData: {
          chainNum: null,
          goodsName: null,
          sellerOrderNum: null,
          carShipNum: null,
          buyerName: null,
          voyage: null,
          sellerName: null,
          salesMan: null,
          createUserName: null,
          salesManager: null,
          time: null,
          contractBusType: null,
          hasFile: null,
          contractTitle: null,
          sellerInvoiceDate: null,
          buyerInvoiceDate: null,
          platInvoiceDate: null,
          createTime: null,
          sellerUserType: null,
          payState: null
        },
        sellerTypeOption: $C.SELLER_TYPE.options,
        oldOrderErrorOption: $C.OLD_ORDERS_ERR.options,
        searchFormItems: [
          {
            title: "搜索",
            span: 24,
            titleAlign: "left",
            titleWidth: 200,
          },
          {
            field: "chainNum",
            title: "总订单编号",
            span: 12,
            titleAlign: "left",
            itemRender: {
              name: "$input",
              props: {placeholder: "输入总订单编号"},
            },
          },
          {
            field: "goodsName",
            title: "货名",
            titleAlign: "left",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入货名"}},
          },
          {
            field: "sellerOrderNum",
            title: "子订单编号",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入子订单编号"},
            },
          },
          {
            field: "carShipNum",
            title: "车船号",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入车船号"},
            },
          },
          {
            field: "buyerName",
            title: "托运人名称",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入托运人名称"},
            },
          },
          // {
          //   field: "voyage",
          //   title: "航次号",
          //   titleAlign: "left",
          //   span: 12,
          //   itemRender: { name: "$input", props: { placeholder: "请输入航次号" } },
          // },
          {
            field: "sellerName",
            title: "承运人名称",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入承运人名称"},
            },
          },
          {
            field: "salesMan",
            title: "业务员",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入业务员"},
            },
          },
          {
            field: "createUserName",
            title: "创建人",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入创建人"},
            },
          },
          {
            field: "salesManager",
            title: "客户经理",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入客户经理"},
            },
          },
          {
            field: "time",
            title: "按创建时间",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择时间", transfer: false},
              options: SEARCH_TIME.options,
            },
          },
          {
            field: "contractBusType",
            title: "按业务类别",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择业务类别", transfer: false},
              options: $C.CONTRACTBUS_TYPE.options,
            },
          },
          {
            field: "hasFile",
            title: "附件筛查",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择是否包含附件", transfer: false},
              options: $C.HAS_FILE_TYPE.options,
            },
          },
          {
            field: "contractTitle",
            title: "订单标题",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入订单标题"},
            },
          },
          {
            align: "right",
            span: 24,
            titleAlign: "left",
            itemRender: {
              name: "$buttons",
              children: [
                {props: {type: "submit", content: "提交", status: "primary"}},
                {props: {type: "reset", content: "重置"}},
              ],
            },
          },
        ],
        amount: {
          totalAssociateCounts: null,
          totalPayAmount: null, // 应付总额
          totalPayedAmount: null, // 已付总额
          totalUnpayAmount: null, // 未付总额
          totalInvoiceAmount: null,
        },
        openType: 0, // 0:新建托运人订单， 1：编辑托运人订单
        rowInfo: null, // 编辑传值
        isSecondSeller: 0,
        paramsObj: {
          isSecondSeller: 0,
          page: 1,
          rows: 10,
        },
        filterGoodsType: [],
        fliterName: null,
        records: []
      };
    },
    watch: {
      "searchFormData.createTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("createTime");
        },
      },
      "searchFormData.sellerInvoiceDate": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("sellerInvoiceDate");
        },
      },
      "searchFormData.buyerInvoiceDate": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("buyerInvoiceDate");
        },
      },
      "searchFormData.platInvoiceDate": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("platInvoiceDate");
        },
      },
    },
    computed: {
      modalTitle() {
        return this.openType === 0 ? "新建承运人订单" : "编辑承运人订单";
      },
    },
    created() {
      this.getList(
        "",
        "buyerNameOptions",
        "ordersSeller",
        "queryOrdersKeyword",
        1
      );
      this.getList(
        "",
        "sellerNameOptions",
        "ordersSeller",
        "queryOrdersKeyword",
        2
      );
      this.getList(
        "",
        "salesManOptions",
        "ordersSeller",
        "queryOrdersKeyword",
        3
      );
      this.getList(
        "",
        "createUserOptions",
        "ordersSeller",
        "queryOrdersKeyword",
        4
      );
      this.getList(
        "",
        "clientNameOptions",
        "ordersSeller",
        "queryOrdersKeyword",
        5
      );
      this.getDicContractBusType();
      this.getOrderList();
      this.$bus.$on("isGetNewSellerOrder", (data) => {
        data === true ? this.queryOrderListByObj(this.paramsObj) : "";
      });
      this.$bus.$on("承运人订单", () => {
        this.reset()
        this.getSearchListKey();
      });
    },
    methods: {
      async fileDownload() {
        let idList = [];
        if (isNotEmpty(this.records)) {
          this.records.forEach(i => {
            idList.push(i.id);
          });
        } else {
          this.$XModal.alert({
            message: "请至少勾选一项",
            status: "error"
          });
          return;
        }
        let params = {
          orderType: 2,
          idList: idList
        };

        showLoading();
        let res = postBlob("/api/tool/download/batchDownloadOrderIds", params);
        hideLoading();
        await saveBlob('附件导出', res.data);
      },
      reset() {
        this.searchFormData = {
          chainNum: null,
          goodsName: null,
          buyerOrdersNum: null,
          carShipNum: null,
          buyerName: null,
          voyage: null,
          sellerName: null,
          salesMan: null,
          createUserName: null,
          salesManager: null,
          time: null,
          contractBusType: null,
          hasFile: null,
          contractTitle: null,
        };
        this.searchBuyerName = [];
        this.searchSellerName = [];
        this.searchSalesMan = [];
        this.searchCreateUser = [];
        this.searchClientName = [];
        this.filterGoodsType = [];
        this.fliterName = null;
        this.getList(
          "",
          "buyerNameOptions",
          "ordersSeller",
          "queryOrdersKeyword",
          1
        );
        this.getList(
          "",
          "sellerNameOptions",
          "ordersSeller",
          "queryOrdersKeyword",
          2
        );
        this.getList(
          "",
          "salesManOptions",
          "ordersSeller",
          "queryOrdersKeyword",
          3
        );
        this.getList(
          "",
          "createUserOptions",
          "ordersSeller",
          "queryOrdersKeyword",
          4
        );
        this.getList(
          "",
          "clientNameOptions",
          "ordersSeller",
          "queryOrdersKeyword",
          5
        );
      },
      getDicContractBusType() {
        this.contractBusTypeOption = [];
        this.filterGoodsType = [];
        $api.other.getContractBusTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: parseInt(item.note),
              };
              this.contractBusTypeOption.push(obj);
            });
          });
        $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictText,
              };
              this.filterGoodsType.push(obj);
            });
            const goodsTypeColumn = this.$refs.xGrid.getColumnByField(
              "goodsType"
            );
            this.$refs.xGrid.setFilter(goodsTypeColumn, this.filterGoodsType);
          });
      },
      filterChangeMethod({values}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          this.fliterName = values[0];
        } else {
          this.fliterName = null;
        }
        this.getOrderList()
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      maxTagPlaceholder(num) {
        return "更多+ " + num;
      },
      remoteMethod(query, options, url, path, columnType) {
        if (query !== "") {
          this.searchLoading = true;
          this.getList(query, options, url, path, columnType);
        } else {
          this[options] = [];
        }
      },
      async getList(query, options, url, path, columnType) {
        let params = {
          columnType: columnType,
          moduleType: 2,
        };

        if (!isEmpty(query)) {
          params.keyword = query;
        }
        if (isEmpty(this[options])) {
          this.searchLoading = true;
        }
        let res = await $api[url].post(path, params);
        this.searchLoading = false;
        if (res.status === 1) {
          this[options] = res.data;
        }
      },
      setDefaultOptions(options, option) {
        this[option] = options;
      },
      refresh() {
        this.queryOrderListByObj(this.paramsObj);
      },
      getCloseModalVal(val) {
        this.isShowAddModal = val;
        // this.getOrderList();
      },
      footerMethod({columns, data}) {
        // 底部合计
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return "单页合计";
            }
            if (["associateCounts"].includes(column.property)) {
              return this.$utils.sum(data, column.property);
            }
            if (
              [
                "payAmount",
                "payedAmount",
                "unpayAmount",
                "invoiceAmount",
              ].includes(column.property)
            ) {
              return formatMoney(this.$utils.sum(data, column.property));
            }
            return null;
          }),
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return "全部合计";
            }
            if (["associateCounts"].includes(column.property)) {
              return this.amount.totalAssociateCounts === null
                ? 0
                : this.amount.totalAssociateCounts;
            }
            if (["payAmount"].includes(column.property)) {
              return formatMoney(this.amount.totalPayAmount);
            }
            if (["payedAmount"].includes(column.property)) {
              return formatMoney(this.amount.totalPayedAmount);
            }
            if (["unpayAmount"].includes(column.property)) {
              return formatMoney(this.amount.totalUnpayAmount);
            }
            if (["invoiceAmount"].includes(column.property)) {
              return formatMoney(this.amount.totalInvoiceAmount);
            }

            return null;
          }),
        ];
      },
      getOrderList() {
        // 获取列表数据
        this.loading = true;
        let obj = {
          isSecondSeller: this.isSecondSeller,
          page: this.page.currentPage,
          rows: this.page.pageSize,
          goodsType: this.fliterName
        };
        $api.order.queryOrdersSellerListModel
          .POST({
            data: obj,
          })
          .then((res) => {
            this.page.totalResult = res.data.total;
            let orderListData = res.data.rows;
            orderListData.map((item) => {
              return Object.assign(item, {
                unpayAmount: item.payAmount - item.payedAmount,
              });
            });
            this.orderListData = orderListData
            // this.$refs.xGrid.reloadData(this.orderListData);
            this.loading = false;
          });

        $api.order.getTotalPayStatisticsMoneyModel
          .POST({
            data: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.amount.totalInvoiceAmount = parseFloat(
                res.data.totalInvoiceAmount
              );
              this.amount.totalPayAmount = parseFloat(
                res.data.totalAccountsPayable
              );
              this.amount.totalPayedAmount = parseFloat(
                res.data.totalAccountPaid
              );
              this.amount.totalUnpayAmount = parseFloat(
                res.data.totalAccountUnpaid
              );
              this.amount.totalAssociateCounts = res.data.totalAssociateCounts;
              setTimeout(() => {
                this.$refs.xGrid.updateFooter();
              }, 0);
              // if (this.orderListData && this.orderListData.length > 0) {
              //   this.$refs.xGrid.reloadData(this.orderListData);
              // }
              // 重新加载数据 统计加载慢
              // setTimeout(() => {
              //   this.$refs.xGrid.reloadData(this.orderListData);
              // }, 0);
            }
          });
      },
      handlePageChange(e) {
        // 分页
        // this.page.currentPage = currentPage;
        // this.page.pageSize = pageSize;
        // this.getOrderList();
        if (this.paramsObj) {
          this.paramsObj.page = e.currentPage;
          this.paramsObj.rows = e.pageSize;
          this.paramsObj.goodsType = this.fliterName
          this.queryOrderListByObj(this.paramsObj);
        } else {
          this.page.currentPage = e.currentPage;
          this.page.pageSize = e.pageSize;
          this.paramsObj.goodsType = this.fliterName
          this.getOrderList();
        }
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      getSearchListKey() {
        let obj = this.searchFormData;
        let paramsObj = {};
        Object.keys(obj).forEach((key) => {
          if (obj[key] !== null && key !== "time") {
            paramsObj[key] = obj[key];
          }
          if (obj["createTime"] && obj["createTime"].length > 0) {
            paramsObj.beginDate = moment(obj.createTime[0]).valueOf(); // 开始时间
            paramsObj.endDate = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["sellerInvoiceDate"] && obj["sellerInvoiceDate"].length > 0) {
            paramsObj.sellerInvoiceBeginDate = moment(
              obj.sellerInvoiceDate[0]
            ).valueOf(); // 开始时间
            paramsObj.sellerInvoiceEndDate =
              moment(obj.sellerInvoiceDate[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["buyerInvoiceDate"] && obj["buyerInvoiceDate"].length > 0) {
            paramsObj.buyerInvoiceBeginDate = moment(
              obj.buyerInvoiceDate[0]
            ).valueOf(); // 开始时间
            paramsObj.buyerInvoiceEndDate =
              moment(obj.buyerInvoiceDate[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["platInvoiceDate"] && obj["platInvoiceDate"].length > 0) {
            paramsObj.platInvoiceBeginDate = moment(
              obj.platInvoiceDate[0]
            ).valueOf(); // 开始时间
            paramsObj.platInvoiceEndDate =
              moment(obj.platInvoiceDate[1]).valueOf() + 86399999; // 结束时间
          }
        });
        paramsObj.page = 1;
        this.page.currentPage = 1;
        paramsObj.rows = this.page.pageSize;
        paramsObj.isSecondSeller = this.isSecondSeller;
        if (this.searchBuyerName.length > 0) {
          paramsObj.buyerName = this.searchBuyerName[0];
        }
        if (this.searchSellerName.length > 0) {
          paramsObj.sellerName = this.searchSellerName[0];
        }
        if (this.searchSalesMan.length > 0) {
          paramsObj.salesMan = this.searchSalesMan[0];
        }
        if (this.searchCreateUser.length > 0) {
          paramsObj.createUserName = this.searchCreateUser[0];
        }
        if (this.searchClientName.length > 0) {
          paramsObj.salesManager = this.searchClientName[0];
        }
        this.paramsObj = paramsObj;
        this.queryOrderListByObj(paramsObj);
        this.searchVisible = false;
      },
      async download() {
        if (isEmpty(this.orderListData)) {
          this.$XModal.message("暂无数据");
          return;
        }
        showLoading();
        let res = postBlob(
          "/api/order/ordersSeller/exportOrdersSellerList",
          this.paramsObj
        );
        hideLoading();
        await saveBlob("导出承运人订单.xls", res.data);
      },
      queryOrderListByObj(obj) {
        this.records = []
        this.loading = true;
        $api.order.queryOrdersSellerListModel
          .POST({
            data: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.page.totalResult = res.data.total;
              this.orderListData = res.data.rows.map((item) => {
                return Object.assign(item, {
                  unpayAmount: item.payAmount - item.payedAmount,
                });
              });
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }

            this.loading = false;
          });
        $api.order.getTotalPayStatisticsMoneyModel
          .POST({
            data: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.amount.totalInvoiceAmount = parseFloat(
                res.data.totalInvoiceAmount
              );
              this.amount.totalPayAmount = parseFloat(
                res.data.totalAccountsPayable
              );
              this.amount.totalPayedAmount = parseFloat(
                res.data.totalAccountPaid
              );
              this.amount.totalUnpayAmount = parseFloat(
                res.data.totalAccountUnpaid
              );
              this.amount.totalAssociateCounts = res.data.totalAssociateCounts;
              setTimeout(() => {
                this.$refs.xGrid.updateFooter();
              }, 0);
              // setTimeout(() => {
              //   this.$refs.xGrid.reloadData(this.orderListData);
              // }, 0);
            }
          });
      },
      createCommit(val) {
        this.importOrderModal = val;
        this.getOrderList();
      },
      confirmEvent(id) {
        // 删除行 提示框
        this.$XModal
          .confirm(
            "删除后，将解除此订单关联的物流信息、收付款信息、发票信息",
            "是否删除此订单？"
          )
          .then((type) => {
            // this.$XModal.message({ message: `点击了 ${type}` });
            if (type === "confirm") {
              $api.order.removeOrdersSellerModel
                .POST({
                  data: {
                    id,
                  },
                })
                .then((res) => {
                  res.status === 1
                    ? this.$XModal.message({message: `删除成功！`})
                    : "";
                  this.queryOrderListByObj(this.paramsObj);
                });
            }
          });
      },
      editOrder(row) {
        // this.getOrderList();
        this.queryOrderListByObj(this.paramsObj);
        this.openType = 1;
        this.isShowAddModal = !this.isShowAddModal;
        this.rowInfo = row;
        this.$refs.createOrder.$refs.saleHeader.init();
        this.$refs.createOrder.$refs.saleHeader.setSaleData(
          this.rowInfo.salesManName,
          this.rowInfo.salesManagerName
        );
      },
      createOrder() {
        this.openType = 0;
        this.isShowAddModal = !this.isShowAddModal;
        this.$refs.createOrder.$refs.saleHeader.init();
      },
      importOrder() {
        this.$refs.modalTemplate.setExport("0609承运人订单导入模板.xls");
        this.templateVisible = true;
      },
      async orderTogether() {
        let confirm = await this.$XModal.confirm('该操作将把承运人订单添加到撮合订单列表,是否继续？')
        if (confirm !== 'confirm') {
          return
        }
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条订单',
            status: "error",
          });
          return
        }
        showLoading();
        let ids = [];
        records.forEach(i => ids.push(i.id))
        let res = await apiPost("api/order", "/ordersSeller/matchOrderSeller", {
          ids: ids,
          type: 2
        });
        hideLoading();
        if (res.status == 1) {
          this.records = []
          this.$Message.success('操作完成');
          await this.refresh();
        } else {
          showErrorData(res.data)
        }
      },


      goImport() {
        this.templateVisible = false;
        this.importOrderModal = true;
      },
      closeTemplate() {
        this.templateVisible = false;
      },
      async commitBatchDelete() {
        let confirm = await this.$XModal.confirm('您确定要批量删除吗？')
        if (confirm !== 'confirm') {
          return
        }
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条订单',
            status: "error",
          });
          return
        }
        showLoading();
        let ids = [];
        records.forEach(i => ids.push(i.id))
        let res = await apiPost("api/order", "/ordersSeller/batchDeleteOrderSeller", {ids});
        hideLoading();
        if (res.status == 1) {
          this.records = []
          this.$Message.success('操作完成');
          await this.refresh();
        } else {
          showErrorData(res.data)
        }
      },
      async commitFileDelete() {
        let confirm = await this.$XModal.confirm('您确定要批量删除附件吗？')
        if (confirm !== 'confirm') {
          return
        }
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条订单',
            status: "error",
          });
          return
        }
        showLoading();
        let ids = [];
        records.forEach(i => ids.push(i.id))
        let res = await apiPost("api/order", "/ordersSeller/batchDeleteContract", {
          ids: ids,
          type: 2
        });
        hideLoading();
        if (res.status == 1) {
          this.records = []
          this.$Message.success('操作完成');
          await this.refresh();
        } else {
          showErrorData(res.data)
        }
      },
      async commitFileCreate() {
        let confirm = await this.$XModal.confirm('您确定要批量生成合同附件吗？')
        if (confirm !== 'confirm') {
          return
        }
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条订单',
            status: "error",
          });
          return
        }
        showLoading();
        let ids = [];
        records.forEach(i => ids.push(i.id))
        let res = await apiPost("api/order", "/ordersSeller/batchCreateContract", {
          ids: ids,
          type: 2
        });
        hideLoading();
        if (res.status == 1) {
          this.records = []
          this.$Message.success('操作完成');
          await this.refresh();
        } else {
          showErrorData(res.data)
        }
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
    },
  };
</script>

<style scoped>
</style>
